import { render } from "./LanguagePicker.vue?vue&type=template&id=b81e7850"
import script from "./LanguagePicker.vue?vue&type=script&lang=js"
export * from "./LanguagePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__